import React from 'react';
import Select from 'react-select'
import style from './Select.module.css';

export const selectSyles = {
  control: styles => ({
    ...styles,
    boxShadow: '0',
    cursor: 'pointer',
    minHeight: '42px',
    fontSize: '14px',
    backgroundColor: '#282C34',
    borderColor: '#282C34',
    marginTop: '0',
    '&:hover': {},
  }),
  input: styles => ({
    ...styles,
    color: '#e8e0d4',
  }),
  menu: styles => ({
    ...styles,
    fontSize: '14px',
    zIndex: '10',
    backgroundColor: '#21252B',
    borderColor: '#21252B',
  }),
  singleValue: (base, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    const color = '#ccc';

    return { ...base, opacity, transition, color, fontSize: '15px' };
  },
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isDisabled
      ? null
      : isSelected
        ? '#282C34'
        : isFocused ? '#33373e' : null,
    color: isDisabled
      ? '#878d98'
      : isSelected
        ? '#ccc'
        : isFocused
          ? '#ccc'
          : '#f1f1f1',
    ':active': {
      backgroundColor: 'rgba(244, 244, 244, 0.1)',
    },
    fontSize: '15px',
  }),
  placeholder: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled
      ? '#383E4A'
      : '#878d98',
  }),
  dropdownIndicator: (styles, { isDisabled }) =>
    ({
      ...styles,
      zIndex: '9',
      opacity: isDisabled ? '0.3' : '1',
      color: '#ccc',
      fill: '#ccc',
      ':hover': {
        color: 'hsl(0,0%,90%)',
      },
    }),
};

const SelectControl = props => (
  <div className={style.root}>
    <div className={style.title}>{props.title}</div>
    <Select
      options={props.options}
      styles={selectSyles}
      components={{ IndicatorSeparator: null }}
      value={props.value}
      onChange={props.onChange}
      isSearchable={props.isSearchable}
    />
  </div>
);

export default SelectControl;
